import { createContext } from "react";

const deploymentContext = createContext();

export default deploymentContext;
